import { InjectionToken } from '@angular/core';
import { IrisActiveCoreFilterService } from '@iris/modules/module-filters-v2/active-filter/core-active-filter.service';

export const IRIS_ACTIVE_FLOATING_FILTER = new InjectionToken<IrisActiveCoreFilterService>('Service providing active floating filter');
